import React from 'react';

import { Button, Modal } from '@common/index';
import { Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { flowActions } from '@store/slices';
import { AppDispatch, State } from '@store/index';
import { InfoOutlined } from '@mui/icons-material';
import { useTheme } from '../../styles/theme';

export const BeginnerRightClickInfo: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useTheme();

  const beginnerRightClickInfo = useSelector((state: State) => state.flow.beginnerRightClickInfo);
  const setOpen = (val: string | null) => dispatch(flowActions.setCloseTab(val));

  const doNotShow = localStorage.getItem('beginnerRightClickInfo') === 'true';
  const open = Boolean(beginnerRightClickInfo && !doNotShow);

  const discard = () => {
    localStorage.setItem('beginnerRightClickInfo', 'true');
    dispatch(flowActions.setBeginnerRightClickInfo(false));
  };

  return (
    <Modal
      open={Boolean(open)}
      setOpen={setOpen as (val: boolean | string | null) => void}
      header='Canvas Tip'
      background={theme.primary}
      icon={<InfoOutlined />}
      info={
        'You can add nodes by right clicking the canvas to open the menu, or dragging an edge from one of the anchors (boxes) on the nodes to open the same menu. The latter will auto connect the execution and data edges for you.\n\nTo use variables in a node sidebar, you need to draw a data edge from the source node that has the data, to the target node you want to use the data inside.'
      }
      actions={
        <Stack direction='row' spacing={1}>
          <Button small customColor='primary' onClick={discard}>
            Got it
          </Button>
        </Stack>
      }
    />
  );
};
